<template>
  <div v-if="mixStr" :id="`quill-toolbar-${mixStr}`" class="toolbar-class quill-toolbar-container">
    <button class="ql-clean"></button>
    <select class="ql-header">
      <option selected></option>
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
    </select>

    <select class="ql-font">
      <option value="SimSun" selected></option>
      <option value="KaiTi"></option>
      <option value="Microsoft-YaHei"></option>
      <option value="SimHei"></option>
    </select>

    <select class="ql-size">
      <option value="9px"></option>
      <option value="10px"></option>
      <option value="11px" selected></option>
      <option value="12px"></option>
      <option value="14px"></option>
      <option value="16px"></option>
      <option value="18px"></option>
      <option value="20px"></option>
      <option value="22px"></option>
      <option value="24px"></option>
      <option value="26px"></option>
      <option value="30px"></option>
    </select>

    <button class="ql-bold"></button>
    <button class="ql-italic"></button>
    <button class="ql-underline"></button>
    <button class="ql-strike"></button>
    <select class="ql-color"></select>
    <select class="ql-background"></select>
    <button class="ql-list" value="ordered"></button>
    <button class="ql-list" value="bullet"></button>
    <button class="ql-indent" value="+1"></button>
    <button class="ql-indent" value="-1"></button>
    <select class="ql-align"></select>
    <!-- <button class="ql-image"></button> -->
    <!-- <button class="ql-link"></button> -->
    <!--添加自己的按钮-->
    <div class="toolbar-dropdown">
      <button id="toolbar-insert" @click="clickInsert">插入</button>
      <div class="toolbar-dropdown-content" v-if="showInsert" ref="contentArea">
        <div v-for="tool in customerTools" :key="tool.id">
          <div class="toolbar-dropdown-content-item" @click.once="clickItem(tool)">
            <Icon :type="tool.icon" />
            <span>{{ tool.description }}</span>
            <input type="file" accept="image/*" id="toolbar-dropdown-content-item-image-label" style="display:none" @change="handleImgInput" v-if="tool.name === 'image'">
            <label for="toolbar-dropdown-content-item-image-label" class="toolbar-dropdown-content-item-image-picker" v-if="tool.name === 'image'"></label>
            <!-- <div class="toolbar-dropdown-content-item-image-picker"><input type="file" accept="image/*" @change="handleImgInput" v-if="tool.name === 'image'"></div> -->
          </div>
        </div>
      </div>
    </div>
    <button id="toolbar-button-m" @click="clickButtonM" v-if="isTemplate">M</button>
    <button id="toolbar-button-t" @click="clickButtonT" v-if="isTemplate">T</button>
    <!-- <input type="file" accept="image/*" @change="handleImgInput"> -->
    <!-- <button @click="test">测</button> -->
    <div :style="inputStyle" ref="inputArea" v-if="showInput">
      <Input v-model="inputValue" @on-enter="inputEnter" placeholder="输入链接，回车确认" ref="inputComponent"></Input>
    </div>
  </div>
</template>

<script>
import { TOPBAR_CUSTOMIZE } from './index'
import { Store } from '../../../common'
import { getCurSelectBounds } from '../../../mixin/docs'
export default {
  name: 'Toolbar',
  data () {
    return {
      showInsert: false,
      customerTools: TOPBAR_CUSTOMIZE,
      showInput: false,
      inputToTop: 0,
      inputToLeft: 0,
      inputValue: '',
      isTemplate: false,
      curIndex: undefined
    }
  },

  props: {
    quill: {
      type: Object,
      default: () => {}
    },
    mixStr: {
      type: String,
      default: ''
    }
  },

  components: {},

  created () {
    let curDoc = Store.store('curDocument')
    this.isTemplate = curDoc.doc_type === '3'
  },

  mounted () {
    this.$nextTick(() => {
      // 点击其他区域隐藏下拉菜单
      // 判断发生在区域外的条件是：
      // 1.点击事件的对象不是目标区域本身
      // 2.实践对象同时不是目标区域的子元素
      document.addEventListener('click', (e) => {
        let dropdownEvent = this.$refs.contentArea
        if (dropdownEvent && !dropdownEvent.isEqualNode(e.target) && !dropdownEvent.contains(e.target)) {
          this.showInsert = false
        }
        let inputEvent = this.$refs.inputArea
        if (inputEvent && !inputEvent.isEqualNode(e.target) && !inputEvent.contains(e.target)) {
          this.showInput = false
        }
      })
    })
  },

  watch: {},

  computed: {
    inputStyle () {
      return {
        position: 'fixed',
        zIndex: '10',
        top: this.inputToTop + 'px',
        left: this.inputToLeft + 'px'
      }
    }
  },

  methods: {
    clickInsert () {
      this.showInsert = !this.showInsert
    },
    clickItem (tool) {
      // console.log('点击了')
      if (tool.name === 'link') {
        var result = getCurSelectBounds(this.quill)
        console.log(result)
        if (result && result.width !== 0) {
          this.inputToTop = result.top + 48
          this.inputToLeft = result.left - 81 + (result.width / 2) + (document.body.clientWidth / 5)
          this.inputValue = ''
          this.showInput = !this.showInput
          setTimeout(() => {
            this.$refs.inputComponent.focus()
          }, 0)
        }
        this.showInsert = !this.showInsert
        return
      }
      if (tool.name === 'image') {
        // console.log('执行了')
        this.showInsert = !this.showInsert
        return
      }
      tool.handleToolbar(this.quill)
      this.showInsert = !this.showInsert
    },
    inputEnter () {
      console.log(this.inputValue)
      var testUrl = /^https?:\/\/.+$/
      if (!testUrl.test(this.inputValue)) {
        this.inputValue = 'http://' + this.inputValue
      }
      this.quill.format('link', this.inputValue)
      this.showInput = !this.showInput
    },
    test () {
      let result = prompt('你开心吗？')
      console.log(result)
    },
    handleImgInput (e) {
      let file = e.target.files[0]
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (arg) => {
        let imgSrc = arg.target.result
        console.log(imgSrc)
        this.quill.format('image', imgSrc)
      }
    },
    clickButtonM () {
      if (this.isNewLine()) {
        this.quill.insertText(this.curIndex, '*`\n\n\n\n`*\n')
      }
    },
    clickButtonT () {
      let curText = this.quill.getText(0)
      let pattern = /\*`\n((?:.|\n)*?)\n`\*/g
      let results = []
      while (true) {
        let matches = pattern.exec(curText)
        if (matches) {
          results.push(matches[1])
        } else {
          break
        }
      }
      console.log(results)
    },
    isNewLine () {
      let range = this.quill.getSelection()
      if (range.length !== 0) {
        return false
      }
      this.curIndex = range.index
      if (this.curIndex === 0) {
        return true
      } else {
        let preCharacter = this.quill.getText(this.curIndex - 1, 1)
        return preCharacter === '\n'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/base.scss";
.toolbar-class {
  display: flex;
  justify-content: center;
}
.toolbar-dropdown {
  position: relative;
}
.toolbar-dropdown-content {
  position: absolute;
  top: 24px;
  z-index: 2;
  padding: 4px 8px;
  background-color: #fff;
  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
  border: 1px solid #ccc;
}
.toolbar-dropdown-content-item {
  width: 64px;
  text-align: left;
  padding: 5px 0;
  font-size: 14px;
  height: 32px;
  position: relative;
  cursor: pointer;
}
.toolbar-dropdown-content-item-image-picker {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  // background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/quill/toolbar/toolbar.vue